import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SimpleSelect from '../../components/SimpleSelect';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { updateAppState } from '../../actions/applicationState';
import { updateUser, updateUserRemote } from '../../actions/user';

import Button from '../../components/Button';
import CancelSubscriptionModal from '../../components/CancelSubscriptionModal';
import ContentContainer from '../../components/ContentContainer';
import HorizontalRule from '../../components/HorizontalRule';
import RenewResubscriptionModal from '../../components/RenewResubscriptionModal';
import TextField from '../../components/TextField';

class SettingsMembership extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line
    console.log(props);

    this.setValue = this.updateTextField.bind(this);
    this.cardModalHandler = this.paymentMethodModalHandler.bind(this);
    this.cancelModalHandler = this.cancelSubscriptionModalHandler.bind(this);
    this.performSave = this.performSave.bind(this);
    this.state = {
      charities: props.appdata.charity.map(charity => ({
        value: charity.id,
        label: charity.title,
      })),
      charity: props.user.charity,
      payment_method_modal_open: false,
      cancel_subscription_modal_open: false,

      billing_first_name: props.user.billing_first_name,
      billing_last_name: props.user.billing_last_name,
      billing_city: props.user.billing_city,
      billing_post_code: props.user.billing_post_code,
      billing_address_1: props.user.billing_address_1,
      billing_address_2: props.user.billing_address_2,
      billing_country: props.user.billing_country,
      billing_email: props.user.billing_email,

      hasErrors: false,

      errors: {
        billing_first_name: false,
        billing_last_name: false,
        billing_email: false,
        billing_city: false,
        billing_post_code: false,
        billing_address_1: false,
        billing_address_2: false,
        billing_country: false,
      },
    };
  }

  updateTextField(key, value) {
    this.setState({
      [key]: value,
    });

    setTimeout(() => {
      if (this.state.errors[key]) {
        // If there is an error against this field, attempt to revalidate
        this.validateForm();
      }
    }, 10);
  }

  paymentMethodModalHandler() {
    this.setState({
      payment_method_modal_open: !this.state.payment_method_modal_open,
    });
  }

  cancelSubscriptionModalHandler() {
    this.setState({
      cancel_subscription_modal_open: !this.state.cancel_subscription_modal_open,
    });
  }

  // Validate the form
  validateForm() {
    const errors = {};

    if (!this.state.billing_first_name || !this.state.billing_first_name.length) {
      errors.billing_first_name = 'Please complete this field';
    } else {
      errors.billing_first_name = null;
    }

    if (!this.state.billing_last_name || !this.state.billing_last_name.length) {
      errors.billing_last_name = 'Please complete this field';
    } else {
      errors.billing_last_name = null;
    }

    if (!this.state.billing_email || !this.state.billing_email.length) {
      errors.billing_email = 'Please complete this field';
    } else {
      errors.billing_email = null;
    }

    if (!this.state.billing_address_1 || !this.state.billing_address_1.length) {
      errors.billing_address_1 = 'Please complete this field';
    } else {
      errors.billing_address_1 = null;
    }

    if (!this.state.billing_city || !this.state.billing_city.length) {
      errors.billing_city = 'Please select a city';
    } else {
      errors.billing_city = null;
    }

    if (!this.state.billing_post_code || !this.state.billing_post_code.length) {
      errors.billing_post_code = 'Please complete this field';
    } else {
      errors.billing_post_code = null;
    }

    if (!this.state.billing_email || !this.state.billing_email.length) {
      errors.billing_email = 'Please complete this field';
    } else {
      errors.billing_email = null;
    }

    if (!this.state.billing_country || !this.state.billing_country.length) {
      errors.billing_country = 'Please complete this field';
    } else {
      errors.billing_country = null;
    }

    if (!this.state.charity || !this.state.charity.length) {
      errors.charity = 'Please complete this field';
    } else {
      errors.charity = null;
    }

    const formErrors = Object.values(errors).some(error => error !== null);

    if (formErrors) {
      this.setState({
        errors,
        hasError: true,
      });

      return false;
    }

    this.setState({
      errors,
      hasError: false,
    });

    return true;
  }

  performSave() {
    if (this.validateForm()) {
      this.props.dispatch(
        updateAppState({
          loading: true,
        }),
      );

      const fields = {
        billing_first_name: this.state.billing_first_name,
        billing_last_name: this.state.billing_last_name,
        billing_email: this.state.billing_email,
        billing_address_1: this.state.billing_address_1,
        billing_address_2: this.state.billing_address_2,
        billing_city: this.state.billing_city,
        billing_post_code: this.state.billing_post_code,
        billing_country: this.state.billing_country,
        charity: this.state.charity,
      };

      this.props.dispatch(updateUserRemote(fields, this.props.user.access_token)).then(
        response => {
          this.props.dispatch(
            updateAppState({
              loading: false,
            }),
          );

          if (response && response.id) {
            this.props.dispatch(updateUser(response));
          }
        },
        err => {
          console.log(err); // eslint-disable-line no-console
          this.props.dispatch(
            updateAppState({
              loading: false,
            }),
          );
        },
      );
    }
  }

  renderCreditCardNumber() {
    const last4 = this.props.user.last4 ? this.props.user.last4 : false;

    if (last4) {
      if (last4.length > 4) {
        return `XXXX-XXXXXX-${last4}`;
      }

      return `XXXX-XXXX-XXXX-${last4}`;
    }

    return 'No credit card saved';
  }

  renderChangePaymentDetailsTitle() {
    return this.props.user.last4 ? 'Change payment details' : 'Add a payment method';
  }

  render() {
    return (
      <ContentContainer>
        <div className={css(styles.container)}>
          <h2 className={css(styles.h2)}>Subscription</h2>
          <div className={css(styles.subscription_container)}>
            <div className={css(styles.membership_info_group, styles.larger)}>
              <div className={css(styles.membership_level)}>Full Membership</div>
              <div className={css(styles.membership_started)}>
                (started {this.props.user.membership_started})
              </div>
            </div>
            <div className={css(styles.membership_info_group)}>
              <div className={css(styles.membership_level)}>$30.00</div>
              <div className={css(styles.membership_started)}>per year</div>
            </div>
            {this.props.user.renew_membership && this.props.user.active_subscription ? (
              <div
                role="link"
                tabIndex={0}
                onClick={this.cancelModalHandler}
                className={css(styles.cancel_link)}
              >
                Cancel my resubscription
              </div>
            ) : (
              <div
                role="link"
                tabIndex={0}
                onClick={this.cardModalHandler}
                className={css(styles.cancel_link)}
              >
                Activate my resubscription
              </div>
            )}
          </div>
          <HorizontalRule />
          <h2 className={css(styles.h2)}>Personal Details</h2>
          <div className={css(styles.form_group)}>
            <TextField
              id="billing_first_name"
              name="billing_first_name"
              label="First Name"
              handler={this.setValue}
              error={this.state.errors.billing_first_name}
              value={this.state.billing_first_name}
            />
            <TextField
              id="billing_last_name"
              name="billing_last_name"
              label="Last Name"
              handler={this.setValue}
              error={this.state.errors.billing_last_name}
              value={this.state.billing_last_name}
            />
          </div>
          <div className={css(styles.form_group)}>
            <TextField
              id="billing_address_1"
              name="billing_address_1"
              label="Address 1"
              handler={this.setValue}
              error={this.state.errors.billing_address_1}
              value={this.state.billing_address_1}
            />
            <TextField
              id="billing_address_2"
              name="billing_address_2"
              label="Address 2"
              handler={this.setValue}
              error={this.state.errors.billing_address_2}
              value={this.state.billing_address_2}
            />
          </div>
          <div className={css(styles.form_group)}>
            <TextField
              id="billing_city"
              name="billing_city"
              label="City"
              handler={this.setValue}
              error={this.state.errors.billing_city}
              value={this.state.billing_city}
            />
            <TextField
              id="billing_post_code"
              name="billing_post_code"
              label="Post Code"
              handler={this.setValue}
              error={this.state.errors.billing_post_code}
              value={this.state.billing_post_code}
            />
          </div>
          <div className={css(styles.form_group)}>
            <TextField
              id="billing_country"
              name="billing_country"
              label="Country"
              handler={this.setValue}
              error={this.state.errors.billing_country}
              value={this.state.billing_country}
            />
            <TextField
              id="billing_email"
              name="billing_email"
              label="Email Address"
              email
              handler={this.setValue}
              error={this.state.errors.billing_email}
              value={this.state.billing_email}
            />
          </div>
          <HorizontalRule />
          <SimpleSelect
            id="charity"
            name="charity"
            options={this.state.charities}
            label="My Favourite Charity"
            required
            value={this.state.charity}
            handler={this.setValue}
            error={this.state.errors.charity}
          />
          <HorizontalRule />
          <div className={css(styles.form_group)}>
            <TextField
              id="credit_card_number"
              disabled
              value={this.renderCreditCardNumber()}
              name="credit_card_number"
              label="Credit Card Number"
            />
            <div
              role="link"
              tabIndex={0}
              onClick={this.cardModalHandler}
              className={css(styles.change_payment_link)}
            >
              {this.renderChangePaymentDetailsTitle()}
            </div>
          </div>
          <HorizontalRule />
          <div className={css(styles.button_container)}>
            <Button
              theme={this.state.hasErrors ? 'disabled' : false}
              title="Save changes"
              handler={this.performSave}
              styles={styles.button}
            />
          </div>
        </div>
        <RenewResubscriptionModal
          dispatch={this.props.dispatch}
          user={this.props.user}
          first_name={this.state.billing_first_name}
          last_name={this.state.billing_last_name}
          current_card={this.renderCreditCardNumber()}
          open={this.state.payment_method_modal_open}
          closeHandler={this.cardModalHandler}
        />
        <CancelSubscriptionModal
          dispatch={this.props.dispatch}
          user={this.props.user}
          open={this.state.cancel_subscription_modal_open}
          closeHandler={this.cancelModalHandler}
        />
      </ContentContainer>
    );
  }
}

SettingsMembership.propTypes = {
  appdata: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
  container: {
    width: 800,
    margin: '0 auto',

    [Theme.mobile_query]: {
      width: 'auto',
    },
  },
  h2: {
    fontSize: 20,
    margin: '45px 5px',
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  subscription_container: {
    backgroundColor: Theme.white,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: 20,
    width: '750',
    height: 100,
    margin: '20px auto',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',

    [Theme.mobile_query]: {
      flexDirection: 'column',
      height: 'auto',
    },
  },
  membership_info_group: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row',

    [Theme.mobile_query]: {
      marginBottom: 15,
      flexDirection: 'column',
    },
  },
  larger: {
    flex: 2,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  membership_level: {
    fontFamily: Theme.font_family_heading,
    fontSize: 20,
    color: Theme.black,
    fontWeight: 'bold',
    marginRight: 10,

    [Theme.mobile_query]: {
      marginBottom: 5,
    },
  },
  membership_started: {
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    color: Theme.grey,
    fontWeight: 'normal',
  },
  cancel_link: {
    display: 'flex',
    flex: 1.5,
    fontSize: 14,
    textAlign: 'right',
    alignItems: 'center',
    justifyContent: 'flex-end',
    color: Theme.primary,
    fontFamily: Theme.font_family_primary,
    cursor: 'pointer',
    fontWeight: 600,
    outline: 'none',
  },
  change_payment_link: {
    display: 'flex',
    flex: 1,
    fontSize: 14,
    textAlign: 'right',
    alignItems: 'center',
    justifyContent: 'flex-end',
    color: Theme.primary,
    fontFamily: Theme.font_family_primary,
    cursor: 'pointer',
    fontWeight: 600,
    outline: 'none',
  },
  button_container: {
    display: 'flex',
    justifyContent: 'flex-end',

    [Theme.mobile_query]: {
      justifyContent: 'center',
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsMembership);



// WEBPACK FOOTER //
// ./src/views/SettingsMembership/index.js